import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import {
  CampagneAdressesService,
  CampagneDetailsService,
  CampagnePlanificationService,
  CampagneTypologieService,
  GlobalDataService,
  resolveCampaignDetailsView,
  resolveCampaignNavigationTarget,
} from '@core/services';
import { NavigationEnd, Router } from '@angular/router';import { CampagneService } from '@core/services/campagne.service';
import { forkJoin, from, Subscription, filter, take, debounceTime } from 'rxjs';
import { AdresseService } from '@core/services/adresse.service';
import { FichierCreaService } from '@core/services/fichier-crea.service';
import { ChampsFusion } from '@core/models/champsFusion.model';
import { FichiersCreation } from '@core/models/FichiersCreation.model';
import { AdresseRetour } from '@core/models/adresseRetour.model';
import { environment } from 'environments/environment';
import { HelpComponent } from 'app/campagne/components';
import { ProduitService } from '@core/services/produit.service';
import { CampagneExt } from '@core/models/campagne-ext.model';
import { Campagne } from '@core/models/campagne.model';
import { CampagneIdentificationService } from '@core/services/campagne-identification.service';
import { PersonalisationService } from '@core/services/personalisation.service';
import { AdressesDestinatairesService } from '@core/services/adresses-destinataires.service';

export interface sidenavItem {
  title: string;
  route?: string;
  icon?: string;
  id?: boolean;
  action(path?: string): void;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  sidenavWidth: string = "8.2rem;";
  logoWidth: string = "4rem;";

  logomargin: string = "2rem;";
  helpmargin: string = "2rem;";


  ngStyle: string = "";

  isLinear = true;

  public sidenavItems: sidenavItem[] = [];
  isExpanded: boolean = false;
  selectedItem = 0;

  version = environment.version;
  private readonly standaloneSelectedMenuStorageKey = 'STANDALONE_SELECTED_MENU_INDEX';
  getAdminDetailsCampagneByIdSub: Subscription | undefined;
  private routerNavigationSubscription: Subscription | undefined;

  constructor(
    public router: Router,
    public _GlobalDataService: GlobalDataService,
    private _CampagneService: CampagneService,
    private _AdresseService: AdresseService,
    public _HelpComponent: HelpComponent,
    private _FichierCreaService: FichierCreaService,
    private _ProduitService: ProduitService,
    private _CampagneTypologieService: CampagneTypologieService,
    private _CampagneAdressesService: CampagneAdressesService,
    private _CampagnePlanificationService: CampagnePlanificationService,
    private _CampagneIdentificationService: CampagneIdentificationService,
    private _PersonalisationService: PersonalisationService,
    private _AdressesDestinatairesService: AdressesDestinatairesService,
    private _CampagneDetailsService: CampagneDetailsService,
  ) {

    console.log('Campagne home page');
  }

  ngOnInit(): void {
    this.waitForRouterReadyThenRestoreState();

    if (this._GlobalDataService.isAdminLaposte()) {
      this.sidenavItems = [   
        {
          title: 'Gestion des annonceurs       ',
          icon: 'lettre1',
          action: this.gotoGestionAnnonceurs.bind(this),
        },
      ];
    }
    else if (this._GlobalDataService.isAdminAnnonceur()) {
      this.sidenavItems = [      
        {
          title: 'Gestion des utilisateurs       ',
          icon: 'bloc-notes2',
          action: this.gotoManageUsers.bind(this),
        },
        {
          title: 'Espace Client           ',
          icon: 'EspaceClient',
          action: this.gotoParametrage.bind(this),
        },
        {
          title: 'Favoris                 ',
          icon: 'EtoileVide',
          action: this.gotoGestionFavoris.bind(this),
        }, 
        {
          title: 'Suivi de campagne        ',
          icon: 'SuiviCampagnes',
          action: this.gotoSuiviCampagne.bind(this),
        }              
      ];
    }
    else {
      this.sidenavItems = [
        {
          title: 'Nouvelle Campagne       ',
          icon: 'lettre1',
          action: this.gotoNewCampagne.bind(this),
        },
        {
          title: 'Détails Campagne       ',
          icon: 'lettre1',
          action: this.gotoDetailCampagne.bind(this),
        },
        {
          title: 'Espace Client           ',
          icon: 'EspaceClient',
          action: this.gotoParametrage.bind(this),
        },
        // {
        //   title: 'Gestion des utilisateurs',
        //   icon: 'bloc-notes2',
        //   action: this.gotoManageUsers.bind(this),
        // },        
        {
          title: 'Favoris                 ',
          icon: 'EtoileVide',
          action: this.gotoGestionFavoris.bind(this),
        },        
        {
          title: 'Suivi de campagne        ',
          icon: 'SuiviCampagnes',
          action: this.gotoSuiviCampagne.bind(this),
        }
      ];
    }
    this.subscribeToRouterNavigation();
    this.initialiseSelectedItemFromSavedState();
    this.syncSelectedItemWithCurrentRoute();
  }
  onSidenavItemClick(index: number, sidenavitem: sidenavItem, event: Event): void {
    this.setSelectedItem(index);
    event.stopPropagation();
    sidenavitem.action();
  }
  ngAfterViewInit(): void {
    // No manual restore here: wait for the router to complete the first navigation.
  }

  private waitForRouterReadyThenRestoreState(): void {
    if (this.router.navigated) {
      this.restoreSavedNavViewState();
      return;
    }
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      debounceTime(50),
      take(1)
    ).subscribe(() => {
      this.restoreSavedNavViewState();
    });
  }
  gotoCreateAnnonceur() {
    console.log('gotoCreerAnnonceur');
    // this.router.navigate([{ outlets: {  navview: ['/administration/admin-campagnes/9'] }}]).then((e) => {
    this._GlobalDataService.saveNavViewState(['create-annonceur'], 'STANDALONE');
    this.router.navigate(["/standalone/home", { outlets: { 'navview': ['create-annonceur'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }

  gotoGestionAnnonceurs() {
    console.log('gotoGestionAnnonceurs');
    this._GlobalDataService.saveNavViewState(['liste-annonceurs'], 'ADMIN');
    this.router.navigate(["/administration/home", { outlets: { 'navview': ['liste-annonceurs'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }


  // async navigate(index: number) {
  //   console.log(index);
  // }

  gotoSuiviCampagne() {
    console.log('gotoSuiviCampagne');
    const annonceurId = this.getResolvedAnnonceurId();
    if (!annonceurId) {
      this._GlobalDataService.openSnackBarInfo("Impossible d'ouvrir le suivi de campagne: annonceur introuvable.");
      return;
    }
    // this.router.navigate([{ outlets: {  navview: ['/administration/admin-campagnes/9'] }}]).then((e) => {
    this._GlobalDataService.saveNavViewState(['suivi-campagnes', annonceurId], 'STANDALONE');
    this.router.navigate(["/standalone/home", { outlets: { 'navview': ['suivi-campagnes', this._GlobalDataService.Annonceur.IdAnnonceur] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }


  gotoNewCampagne(): void {
    this._GlobalDataService.resetForNewCampaign();
    this.initialise();
    this._PersonalisationService.reset();
    this._AdressesDestinatairesService.reset();

    this._GlobalDataService.saveNavViewState(['nouvelle-campagne'], 'STANDALONE');
    this.router.navigate(['/standalone/home', { outlets: { navview: ['nouvelle-campagne'] } }], {
      queryParams: this._GlobalDataService.objectParams,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
    });
  }

  navigate(view: string, IdCampagne: string) {
    let path = "/campagne/home";

    if (this._GlobalDataService.isStandaloneContext()) {
      path = "/standalone/home"
    }
    this._GlobalDataService.saveNavViewState([view, IdCampagne], this._GlobalDataService.CONTEXT || 'STANDALONE');
    this.router.navigate([path, { outlets: { 'navview': [view, IdCampagne] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }


  gotoDetailCampagne() {
    const currentRouteTarget = resolveCampaignNavigationTarget(this.getCurrentNavViewCommands());
    const savedTarget = resolveCampaignNavigationTarget(
      this._GlobalDataService.getSavedNavViewState('STANDALONE')
    );
    const persistedCampaignTarget = resolveCampaignNavigationTarget(
      this._GlobalDataService.getSavedCurrentCampaignNavigation('STANDALONE')
    );
    const inMemoryCampaignId = this._GlobalDataService.Campagne?.IdCampagne == null
      ? ''
      : String(this._GlobalDataService.Campagne.IdCampagne).trim();
    const target = currentRouteTarget ||
      (inMemoryCampaignId
        ? {
            view: resolveCampaignDetailsView(this._GlobalDataService.Campagne),
            campaignId: inMemoryCampaignId,
          }
        : null) ||
      persistedCampaignTarget ||
      savedTarget;

    if (!target) {
      this._GlobalDataService.alert("Aucune campagne en cours.");
      return;
    }

    const campagne = {
      ...(this._GlobalDataService.Campagne || new Campagne()),
      IdCampagne: target.campaignId,
    } as Campagne;
    if (typeof campagne.EmailNotification === 'undefined') {
      campagne.EmailNotification = '';
    }
    this._CampagneDetailsService.openCampaign(campagne, target.view);
  }

  private getCurrentNavViewCommands(): string[] | null {
    try {
      const segments = this.router.parseUrl(this.router.url).root.children['navview']?.segments || [];
      return segments.map(segment => segment.path);
    } catch {
      return null;
    }
  }


  gotoParametrage() {
    console.log('gotoParametrage');
    this._GlobalDataService.saveNavViewState(['parametrage'], 'STANDALONE');
    this.router.navigate(["/standalone/home", { outlets: { 'navview': ['parametrage'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }

  gotoGestionFavoris() {
    console.log('gotoGestionFavoris');
    this._GlobalDataService.saveNavViewState(['gestion-favoris'], 'STANDALONE');
    this.router.navigate(["/standalone/home", { outlets: { 'navview': ['gestion-favoris'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }



  gotoManageUsers() {
    console.log('gotoManageUsers');
    this._GlobalDataService.saveNavViewState(['manage-users'], 'STANDALONE');
    this.router.navigate(["/standalone/home", { outlets: { 'navview': ['manage-users'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }

  gotoUserProfile() {
    console.log('gotoUserProfile');
    this._GlobalDataService.saveNavViewState(['user-profile'], 'STANDALONE');
    this.router.navigate(["/standalone/home", { outlets: { 'navview': ['user-profile'] } }], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    }).then((e) => {
      if (e) {
        console.log("Navigation is successful!");
      } else {
        console.log("Navigation has failed!");
      }
    });
  }

  initialise() {

    this._GlobalDataService.CampagneExt.Produit = {};
    this._GlobalDataService.CampagneExt.VitessesProduit = new Array<string>();
    this._GlobalDataService.CampagneExt.Adresse = new AdresseRetour(this._GlobalDataService.Annonceur);
    this._GlobalDataService.CampagneExt.FichiersCreation = new Array<FichiersCreation>();
    this._GlobalDataService.CampagneExt.ChampsFusion = new Array<ChampsFusion>();
    this._GlobalDataService.CampagneExt.FichiersCreationsURL = {};
    this._GlobalDataService.CampagneExt.FichiersCreationsType = {};
    this._GlobalDataService.CampagneExt.NbFichiersCreation = 0;
    this._GlobalDataService.CampagneExt.NbFichiersPersonnalisation = 0;
    this._GlobalDataService.CampagneExt.NbFichiersLogo = 0;

    this._GlobalDataService.CampagneExt.VitessesProduit = ['Classique', 'Rapide'];

    this._GlobalDataService.Campagne.volume="";
    this._GlobalDataService.Campagne.unitAmountWithoutTax="";
    this._GlobalDataService.Campagne.amountWithoutTax = "";

    this._GlobalDataService.Campagne.showInfo = false;
    this._GlobalDataService.Campagne.showRefresh = false;
    this._GlobalDataService.Campagne.showunitAmountWithoutTax = false;
    this._GlobalDataService.Campagne.showamountWithoutTax = false;
    this._GlobalDataService.Campagne.OptionRetour = '';
    this._GlobalDataService.checkStepCompletion();

    //  Reset Forms
    this._CampagneAdressesService.reset();

    this._CampagnePlanificationService.reset();

    this._CampagneTypologieService.reset();

    this._CampagneIdentificationService.reset();
  }

  SuccessCurrentCampagne(campagne) {
  if (typeof campagne === 'object' && campagne?.IdCampagne) {
    this._GlobalDataService.Campagne = campagne;

    if (typeof this._GlobalDataService.Campagne.EmailNotification == 'undefined') {
      this._GlobalDataService.Campagne.EmailNotification = '';
    }

    this._GlobalDataService.CampagneExt = new CampagneExt();

    console.log('current Campagne : ', this._GlobalDataService.Campagne);
    console.log('Id Campagne : ', this._GlobalDataService.Campagne.IdCampagne);
    console.log('campagne.StatutCampagne', campagne.StatutCampagne);
    console.log('campagne.CodeStatut', campagne.CodeStatut);

    this.initialise();

    this._GlobalDataService.isLoaded = true;

    this._GlobalDataService.saveNavViewState(
      ['campagne-details', this._GlobalDataService.Campagne.IdCampagne],
      'STANDALONE'
    );

    this.router
      .navigate(
        [
          '/standalone/home',
          {
            outlets: {
              navview: [
                'campagne-details',
                this._GlobalDataService.Campagne.IdCampagne,
              ],
            },
          },
        ],
        {
          queryParams: this._GlobalDataService.objectParams,
          queryParamsHandling: 'merge',
          skipLocationChange: false,
        }
      )
      .then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
  } else {
    this._GlobalDataService.isLoaded = true;

    /**
     * Important :
     * On ne doit pas écraser systématiquement le state avec nouvelle-campagne
     * si une autre route utile existe déjà.
     */
    const savedState =
      this._GlobalDataService.getSavedNavViewState('STANDALONE');

    if (!savedState || !savedState.length || savedState[0] === 'bienvenue') {
      this._GlobalDataService.saveNavViewState(
        ['nouvelle-campagne'],
        'STANDALONE'
      );
    }

    this.router
      .navigate(
        ['/standalone/home', { outlets: { navview: ['nouvelle-campagne'] } }],
        {
          queryParams: this._GlobalDataService.objectParams,
          queryParamsHandling: 'merge',
          skipLocationChange: false,
        }
      )
      .then((e) => {
        if (e) {
          console.log('Navigation is successful!');
        } else {
          console.log('Navigation has failed!');
        }
      });
  }

  this._GlobalDataService.campagneBeforeChanges = Object.assign(
    {},
    this._GlobalDataService.Campagne
  );
}

  ErrorCurrentCampagne(error: string) {
    //une erreur est survenue => redirection page erreur
    console.log('CreationCampagneComponent : ErrorCurrentCampagne', error)
    this.router.navigate(['/erreur'], {
      queryParams: this._GlobalDataService.objectParams, queryParamsHandling: "merge",
      skipLocationChange: false
    });
    this._GlobalDataService.isLoaded = true;
  }



  increase() {
    this.isExpanded = true;
  }
  decrease() {
    this.isExpanded = false;
  }

  openHelp() {
    this._GlobalDataService.referenceDocHelp = '';
    this._HelpComponent.OpenHelpFile();
  }

  gotoMentionsLegales(){
    let path = 'standalone/home'
    this._GlobalDataService.saveNavViewState(['mentions-legales'], 'STANDALONE');
    this.router.navigate([path, {outlets : {'navview' : 'mentions-legales'}}])
  }
  private restoreSavedNavViewState(): void {
  console.debug('restoreSavedNavViewState()', {
    url: this.router.url,
    navigated: this.router.navigated,
    hasNavViewOutlet: this.hasActiveNavViewOutlet() || !!this.router.parseUrl(this.router.url).root.children['navview'],
    savedState: this._GlobalDataService.getSavedNavViewState('STANDALONE')
  });

  if (!this.router.navigated) {
    return;
  }

  const parsedUrl = this.router.parseUrl(this.router.url);
  const currentNavViewPath =
    parsedUrl.root.children['navview']?.segments?.[0]?.path;

  const commands = this._GlobalDataService.getSavedNavViewState('STANDALONE');

  const hasNavViewOutlet =
    this.hasActiveNavViewOutlet() ||
    !!parsedUrl.root.children['navview'];

  if (hasNavViewOutlet) {
    this.syncSelectedItemWithCurrentRoute();
    return;
  }

  if (!commands || !commands.length) {
    return;
  }

  const savedPath = typeof commands[0] === 'string' ? commands[0] : null;
  const selectedIndex = this.getSelectedIndexByNavViewPath(savedPath);

  if (selectedIndex !== null) {
    this.setSelectedItem(selectedIndex);
  }

  this.router.navigate(['/standalone/home', { outlets: { navview: commands } }], {
    queryParams: this._GlobalDataService.objectParams,
    queryParamsHandling: 'merge',
    skipLocationChange: false,
    replaceUrl: true,
  });
}

  private hasActiveNavViewOutlet(): boolean {
    const root = this.router.routerState.snapshot.root;
    return this.hasNamedOutlet(root, 'navview');
  }

  private hasNamedOutlet(route: import('@angular/router').ActivatedRouteSnapshot, outlet: string): boolean {
    if (route.outlet === outlet) {
      return true;
    }
    return route.children.some(child => this.hasNamedOutlet(child, outlet));
  }
  private subscribeToRouterNavigation(): void {
    this.routerNavigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.syncSelectedItemWithCurrentRoute();
      }
    });
  }
  private initialiseSelectedItemFromSavedState(): void {
    const persistedSelectedItem = this.getPersistedSelectedItem();
    if (persistedSelectedItem !== null) {
      this.selectedItem = persistedSelectedItem;
    }
    const savedPath = this.getSavedStandaloneNavViewPath();
    const selectedIndex = this.getSelectedIndexByNavViewPath(savedPath);
    if (selectedIndex !== null) {
      this.setSelectedItem(selectedIndex);
    }
  }
  private syncSelectedItemWithCurrentRoute(): void {
    const currentUrl = this.router.url || '';
    const parsedUrl = this.router.parseUrl(currentUrl);
    const navViewPath = parsedUrl.root.children['navview']?.segments?.[0]?.path;
    const selectedIndex = this.getSelectedIndexByNavViewPath(navViewPath);
    if (selectedIndex !== null) {
      this.setSelectedItem(selectedIndex);
      return;
    }
    if (!parsedUrl.root.children['navview'] && currentUrl.startsWith('/standalone/home')) {
      const savedPath = this.getSavedStandaloneNavViewPath();
      const selectedIndexFromSavedState = this.getSelectedIndexByNavViewPath(savedPath);
      if (selectedIndexFromSavedState !== null) {
        this.setSelectedItem(selectedIndexFromSavedState);
        return;
      }
      const persistedSelectedItem = this.getPersistedSelectedItem();
      if (persistedSelectedItem !== null) {
        this.selectedItem = persistedSelectedItem;
      }
    }
  }
  private getPersistedSelectedItem(): number | null {
    const storedValue = this.readStorageValue(this.standaloneSelectedMenuStorageKey);
    if (storedValue === null) {
      return null;
    }
    const parsedValue = Number(storedValue);
    return Number.isInteger(parsedValue) ? parsedValue : null;
  }
  private setSelectedItem(index: number): void {
    this.selectedItem = index;
    this.writeStorageValue(this.standaloneSelectedMenuStorageKey, String(index));
  }
  private readStorageValue(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }
  private writeStorageValue(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Ignore storage errors to keep the app usable.
    }
  }
  private getSavedStandaloneNavViewPath(): string | null {
    const commands = this._GlobalDataService.getSavedNavViewState('STANDALONE');
    if (!commands || !commands.length || typeof commands[0] !== 'string') {
      return null;
    }
    return commands[0];
  }
  private getResolvedAnnonceurId(): string | null {
    const annonceurId = this._GlobalDataService?.Annonceur?.IdAnnonceur;
    if (annonceurId && annonceurId !== '0') {
      return String(annonceurId);
    }
    const jwtAnnonceurId = this._GlobalDataService.getJWTAnnonceurId();
    if (jwtAnnonceurId && jwtAnnonceurId !== -1) {
      return String(jwtAnnonceurId);
    }
    return null;
  }
  private getSelectedIndexByNavViewPath(path: string | null): number | null {
    if (!path) {
      return null;
    }
    const isSuiviPath = path.startsWith('suivi-');
    if (this._GlobalDataService.isAdminLaposte()) {
      return ['liste-annonceurs', 'create-annonceur', 'manage-annonceurs'].includes(path) ? 0 : null;
    }
    if (this._GlobalDataService.isAdminAnnonceur()) {
      if (['manage-users', 'user-profile', 'create-user'].includes(path)) {
        return 0;
      }
      if (path === 'parametrage') {
        return 1;
      }
      if (path === 'gestion-favoris') {
        return 2;
      }
      if (isSuiviPath) {
        return 3;
      }
      return null;
    }
    if (path === 'nouvelle-campagne' || path === 'campagne-details') {
      return 0;
    }
    if (['validation-bat', 'message-confirmation'].includes(path)) {
      return this.getPersistedSelectedItem() ?? 1;
    }
    if (path === 'parametrage') {
      return 2;
    }
    if (path === 'gestion-favoris') {
      return 3;
    }
    if (isSuiviPath) {
      return 4;
    }
    return null;
  }

  ngOnDestroy() {
    if (this.getAdminDetailsCampagneByIdSub) this.getAdminDetailsCampagneByIdSub.unsubscribe();
    if (this.routerNavigationSubscription) this.routerNavigationSubscription.unsubscribe();
  }

}
